import { lazy, Suspense } from "react";
import { useQueuedPopup } from "@/hooks/useQueuedPopup";
import { POPUP_CONFIGS } from "@/config/popupConfig";
import { useWheelEntry } from "@/modules/wheel/hooks";
import { ROUTES } from "../../../utils/navigation";

const WheelActivityDialog = lazy(() =>
  import("../components/WheelActivity/WheelActivityDialog").then(m => ({
    default: m.WheelActivityDialog,
  }))
);

/**
 * 抽奖转盘活动弹窗（仅入口点击打开）。
 * 三个入口(useWheelEntryClick)通过 triggerPopup 手动触发，不自动弹出。
 */
export const useWheelActivityPopup = () => {
  const { wheel } = useWheelEntry();

  useQueuedPopup({
    popupId: POPUP_CONFIGS.LUCKY_WHEEL_ACTIVITY.id,
    priority: POPUP_CONFIGS.LUCKY_WHEEL_ACTIVITY.priority,
    // 仅手动触发，且转盘已启用
    shouldShow: ctx => !!ctx?.isManualTrigger && !!wheel,
    renderContent: onComplete =>
      wheel ? (
        <Suspense fallback={null}>
          <WheelActivityDialog config={wheel} onClose={onComplete} />
        </Suspense>
      ) : null,
    allowManualTrigger: true,
    autoTrigger: false,
    // 入口在首页(banner/浮标)与活动列表页(EventCenter)。不配 allowedPaths 时队列默认只放行首页，
    // 导致在活动列表页点入口后弹窗挂在队列里、切回首页才弹。这里放行入口所在页面。
    allowedPaths: [
      ROUTES.HOME,
      ROUTES.HOME_ALT,
      "/",
      ROUTES.EVENT_CENTER,
      ROUTES.LOGIN,
      ROUTES.REGISTER,
    ],
    dependencies: [wheel],
  });
};
